module.exports = __webpack_public_path__ + "static/media/48376831_2309076809167497_4627894829865500672_o-thumb.eee46e2b.jpg";